<lex-doc-viewer-dialog>
  <div dialog-title>OpenAI Integration Settings</div>
  <div dialog-body style="padding: 0px 16px 14px">
    <form [formGroup]="openAiSettingForm" style="display: flex;
  flex-direction: column;
  justify-content: space-evenly; gap: 10px;">
      <div>
        <lex-text-input label="API Settings" formControlName="apiKey" placeholder="Enter your API key..."></lex-text-input>
        <mat-hint class="input-hint">For more information about API key, see <a class="input-hint-link" href="https://sites.google.com/a/ediscoveryplatform.com/help/home/help/management-menu/third-party-applications" target="_blank">Help Page</a></mat-hint>
      </div>
      <div class="form-group">
        <div class="form-container" style="margin-right:2px;">
          <label for="api-model">API Model</label>
          <mat-select matNativeControl id="api-model" formControlName="apiModel" style="height: 28px; border: 1px solid #565656;
        border-radius: 5px; display: flex; align-items: center; padding-left: 8px; width: calc(100% - 8px);">
            <mat-option *ngFor="let model of models" [value]="model.value">
              {{model.name}}
            </mat-option>
          </mat-select>
        </div>
        <mat-hint class="input-hint">For more information on OpenAI models, see <a class="input-hint-link" href="https://sites.google.com/a/ediscoveryplatform.com/help/home/help/document-viewer/smart-tab" target="_blank">Smart Tab Insights</a></mat-hint>
      </div>
    </form>
  </div>
  <div dialog-actions style="display: flex; flex-direction: row; justify-content: space-between; margin: 2px; padding: 6px;">
    <div>
      <lex-flat-button label="Unlink" [icon]="'fa-thin fa-link-slash'" [type]="'action'" *ngIf="isLinked" (click)="emptyProps()"></lex-flat-button>
    </div>
    <div style="display:flex; gap: 4px;">
      <lex-flat-button *ngIf="!isLinked" label="Link" [icon]="'fa-thin fa-brain-circuit'" [type]="'action'" (click)="link()" [disabled]="openAiSettingForm.invalid"></lex-flat-button>
      <lex-flat-button *ngIf="isLinked" label="Update" [icon]="'fa-thin fa-brain-circuit'" [type]="'action'" (click)="submit()" [disabled]="openAiSettingForm.invalid || !(openAiSettingForm.controls['apiKey'].dirty || openAiSettingForm.controls['apiModel'].dirty)"></lex-flat-button>
      <lex-icon-button [icon]="'fa-thin fa-xmark-large'" [type]="'action'" mat-dialog-close matTooltip="Cancel"></lex-icon-button>
    </div>
  </div>
</lex-doc-viewer-dialog>